/* eslint-disable react-hooks/exhaustive-deps */
// react
import queryString from "query-string"
import { useEffect, useState } from "react"
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Form,
  Row,
} from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { Link, useHistory, useLocation } from "react-router-dom"

// wijmo
import {
  faChevronDown,
  faChevronUp,
  faSearch,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjCore from "@grapecity/wijmo"
import * as wjGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"

// other
import { AppDispatch } from "../../.."

// Kairos
import AlertComponent from "../../../components/AlertComponent"
import DisplaySearchConditionLabel from "../../../components/DisplaySearchConditionLabel"
import FlexGridOuter from "../../../components/FlexGridWrapper/FlexGridOuter"
import Spinner from "../../../components/Spinner"
import CONST from "../../../constant"
import { clearAlert, setAlerts } from "../../../globalStore/alertStore"
import {
  画面ロック解除,
  画面ロック開始,
} from "../../../globalStore/progressStore"

import dayjs from "dayjs"
import { RootState } from "../../../globalStore/rootreducer"
import {
  UriageYosanAllListGetReq,
  UriageYosanZensyaListRes,
} from "../../../service/budget/uriageYosan/TUriageYosan"
import uriageYosanService from "../../../service/budget/uriageYosan/uriageYosanService"
import gridPageHelper from "../../../ts/helpers/gridPageHelper"
import pageHelper from "../../../ts/helpers/pageHelper"
import util from "../../../ts/util"
import { 予算_実績メニューコード } from "../../../constant/menuCode"
import {
  T年ComboBoxItem,
  YearComboBox,
} from "../../../components/ComboBox/YearComboBox"
import { TWijmoComboBox } from "../../../type/wijmoComponents"
import { quotOrZero } from "../../../ts/util/decimalUtil"
import Decimal from "decimal.js"

/**
 *　売上予算（全社年間）
 * @returns
 */
const UriageYosanZensyaList = () => {
  const history = useHistory()
  const location = useLocation()
  const 当営業日 = useSelector((state: RootState) => state.date.eigyobiStr)

  let gridId = "UriageYosanZensyaList_GridId"

  //#region [method]

  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページ当たりの行数
   * @returns CollectionView
   */
  const createCollectionView = (data: Array<any>, pageSize: number) =>
    new wjCore.CollectionView(data, {
      pageSize,
      groupDescriptions: [new wjCore.PropertyGroupDescription("営業所名")],
      // GridFooterからのイベント伝達用
      onPageChanged() {
        if (flexGrid && flexGrid.itemsSource) {
          const pageIndex = flexGrid!.itemsSource!.pageIndex
          setPageNumber(pageIndex)
        }
      },
    })

  /**
   * 検索処理
   * @param searchCondition 検索条件
   */
  const search = async (searchCondition?: UriageYosanAllListGetReq) => {
    if (!年度) return

    setIsSearching(true) // 検索中状態に遷移
    dispatch(clearAlert()) // アラートを非表示に

    let currentSearchCondition: UriageYosanAllListGetReq
    // 検索条件生成
    if (searchCondition) {
      // 引数の検索条件を使用
      currentSearchCondition = searchCondition
    } else {
      // stateから検索条件を生成
      currentSearchCondition = createSearchCondition()
    }
    // QueryStringに検索条件を反映
    pageHelper.pushQuery(history, location, currentSearchCondition)

    //表示用の検索条件を作成
    setDisplaySearchCondition(
      createDisplaySearchCondition(currentSearchCondition)
    )

    try {
      const res = await new uriageYosanService().getUriageYosanZensyaList(
        currentSearchCondition
      )

      // 検索結果をstateにセット
      setGridData({ data: createCollectionView(res.data, pageSize) })
    } catch (error) {
      dispatch(setAlerts(error))
    } finally {
      setIsSearching(false) // 検索中状態に遷移
    }
  }

  /**
   * URL Queryを解析
   */
  const queryParse = () => {
    const query = queryString.parse(
      location.search
    ) as unknown as UriageYosanAllListGetReq

    if (query.年度 != null && typeof query.年度 === "number") {
      set年度(query.年度)
    }
    return query
  }

  /**
   * 検索条件オブジェクトを生成
   */
  const createSearchCondition = (): UriageYosanAllListGetReq => {
    return {
      年度: 年度 ?? 0,
    }
  }

  /**
   * 表示用検索条件オブジェクトを生成
   */
  const createDisplaySearchCondition = (
    searchCondition: UriageYosanAllListGetReq
  ) => {
    return {
      年度:
        searchCondition.年度 != null
          ? `${searchCondition.年度}年度`
          : undefined,
    }
  }

  /**
   * 検索条件クリア処理
   */
  const searchConditionClear = () => {
    // フィルターのクリア
    if (!isSearching) {
      flexGrid!.collectionView.filter = null
      flexGrid!.collectionView.sortDescriptions.clear()
    }
    // データをすべて削除する
    const emptyCollectionView = createCollectionView([], pageSize)
    flexGrid!.itemsSource = emptyCollectionView
    setGridData({ data: emptyCollectionView })
    // 検索条件文字列をクリア
    setDisplaySearchCondition(undefined)

    clearSearchState()
    // querystringをクリア
    pageHelper.clearQuery(history, location)
  }

  const clearSearchState = () => {
    set年度(dayjs(当営業日).year())
  }

  // グリッド初期化時イベントハンドラ
  const gridInitializedHandler = async (grid: wjGrid.FlexGrid) => {
    // 集計行追加
    const footer = new wjGrid.GroupRow()
    grid.columnFooters.rows.push(footer)
    grid.columnFooters.setCellData(0, 0, "総計")

    grid.formatItem.addHandler(formatItem)
    grid.refresh()
  }

  /**
   * グリッドのフォーマット
   */
  const formatItem = (f: wjGrid.FlexGrid, e: wjGrid.FormatItemEventArgs) => {
    if (e.panel === f.columnFooters) {
      const row = f.columnFooters.rows[e.row]
      if (row instanceof wjGrid.GroupRow) {
        if (e.getColumn().binding === "前期実績比") {
          const dataItems: UriageYosanZensyaListRes[] =
            f.collectionView.sourceCollection
          const 今期予算総計 = dataItems.reduce(
            (A, B) => new Decimal(A).plus(B.今期予算).toNumber(),
            0
          )
          const 前期実績総計 = dataItems.reduce(
            (A, B) => new Decimal(A).plus(B.前期実績).toNumber(),
            0
          )
          // 合計の前年実績比を計算する
          f.columnFooters.setCellData(
            e.row,
            "前期実績比",
            quotOrZero(今期予算総計, 前期実績総計),
            false
          )
        }
      }
    } else if (e.panel === f.cells) {
      if (e.getColumn().binding === "前期実績比") {
        const row = f.rows[e.row]
        const item = f.rows[e.row].dataItem
        const group = row instanceof wjGrid.GroupRow ? item : null
        if (group) {
          const 前期実績 = group.getAggregate(wjCore.Aggregate.Sum, "前期実績")
          const 今期予算 = group.getAggregate(wjCore.Aggregate.Sum, "今期予算")
          e.cell.textContent = wjCore.Globalize.formatNumber(
            quotOrZero(今期予算, 前期実績),
            "p2%"
          )
        }
      }
    }
  }

  /**
   * 明細グリッドセル結合マネージャー
   */
  class RestrictedMergeManager extends wjGrid.MergeManager {
    getMergedRange(p: wjGrid.GridPanel, r: number, c: number, clip = true) {
      var rng = null
      rng = new wjGrid.CellRange(r, c)
      const マージ判定用bindList: { binding: string; isRequired: boolean }[] = [
        {
          binding: "営業所名",
          isRequired: true,
        },
      ]
      const マージ対象bindList: string[] = ["営業所名"]
      const isMergeCell = (rowNumber: number) => {
        return !マージ判定用bindList.find((bindListItem) => {
          const cellValue = p.getCellData(r, bindListItem.binding, true)
          const prevRowValue = p.getCellData(
            rowNumber - 1,
            bindListItem.binding,
            true
          )
          if (bindListItem.isRequired && !cellValue) return true
          return cellValue !== prevRowValue
        })
      }

      // bindListの列が全て同じ値であれば結合する
      if (マージ対象bindList.includes(p.columns[c].binding ?? "")) {
        // セルの現在位置の上のセルと比較
        while (rng.row > 0 && isMergeCell(rng.row)) {
          rng.row--
        }
        // セルの現在位置の下のセルと比較
        while (rng.row2 < p.rows.length - 1 && isMergeCell(rng.row2 + 2)) {
          rng.row2++
        }
        if (rng.isSingleCell) {
          rng = null
        }
      }
      return rng
    }
  }

  //#endregion

  //#region [baseState]

  // リストア制御用フラグ
  const [isRestoreSearching, setIsRestoreSearching] = useState<boolean>(false)

  const [flexGrid, setFlexGrid] = useState<wjGrid.FlexGrid>()
  const [pageSize, setPageSize] = useState<number>(0)
  const [gridData, setGridData] = useState<{ data: wjCore.CollectionView }>({
    data: createCollectionView([], pageSize),
  })
  const [pageNumber, setPageNumber] = useState<number>(0)

  // 検索制御用
  const [isSearching, setIsSearching] = useState(false) // 検索中

  // 検索条件表示用
  const [displaySearchCondition, setDisplaySearchCondition] = useState<{
    [propertyName: string]: any
  }>()

  //アラート制御
  const dispatch: AppDispatch = useDispatch()

  // Accordion制御
  const [accordionController, setAccordionController] = useState<boolean>(true)

  //grid初期化フラグ
  const [gridInitialized, setGridInitialized] = useState<boolean>(false)

  //#endregion

  //#region [state]

  const [年度, set年度] = useState<number | null>()

  // 年度
  const [年度ComboBox, set年度ComboBox] = useState<TWijmoComboBox<
    number | undefined,
    T年ComboBoxItem
  > | null>(null)
  const [年度isLoadEnded, set年度isLoadEnded] = useState<boolean>(false)

  //#endregion

  //#region [effect]
  //初期設定
  useEffect(() => {
    set年度(dayjs(当営業日).year())
  }, [])

  // wijmoコンポーネントの初期化 および ComboBoxなどのロード完了後、前回状態の復元処理を行う
  useEffect(() => {
    //gridやcomboBoxの生成完了を確認
    if (gridInitialized) {
      //初回filter作成時にqueryがいた場合、検索を行う
      if (location.search !== "") {
        // 遷移してきた際のクエリパラメータで検索条件を生成
        const querySearchCondition = queryParse()

        // リストア中フラグON
        setIsRestoreSearching(true)

        // 再検索
        search(querySearchCondition).finally(() => {
          dispatch(画面ロック解除())
        })
      } else {
        // 単純遷移の場合はフィルタ条件を削除する
        gridPageHelper.removePageConditionData()
        gridPageHelper.removeAllGridFilterAndSortStates()
        dispatch(画面ロック解除())
      }
    }
  }, [gridInitialized])

  useEffect(() => {
    document.title = `売上予算（全社）`
    // 初期表示生成のため画面ロック
    dispatch(画面ロック開始())
  }, [])
  //#endregion

  return (
    <Container fluid>
      {/* 画面タイトル */}
      <Row className="page-title-row">
        <Col className="page-title-col">
          <span className="page-title">売上予算（全社）</span>
        </Col>
      </Row>
      {/* アラート表示 */}
      <Row>
        <Col>
          <AlertComponent />
        </Col>
      </Row>

      <Row>
        <Col>
          <Card className="w-20rem">
            <Card.Body>
              <div>
                <Button className="mx-1" disabled={true}>
                  全社
                </Button>
                <Link
                  to={util.getMenuPath(予算_実績メニューコード.売上予算)[0]}
                  onClick={() =>
                    gridPageHelper.savePageConditionData(location.pathname)
                  }>
                  <Button className="mx-1" disabled={isSearching}>
                    部所（年）
                  </Button>
                </Link>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索条件カード */}
          <Card className="w-20rem">
            {/* CardHeaderをアコーディオン化 */}
            <Card.Header
              onClick={() => setAccordionController(!accordionController)}
              aria-controls="collapse-search-card-body"
              aria-expanded={accordionController}>
              <FontAwesomeIcon
                icon={accordionController ? faChevronDown : faChevronUp}
                size={"1x"}
              />
              検索条件
            </Card.Header>
            <Collapse in={accordionController}>
              <Card.Body>
                <Form>
                  <Container fluid className="contents-search-main">
                    <Row>
                      <Col>
                        <div className="search-condition-table">
                          <div className="search-condition-row">
                            <div className="w-8rem">
                              <YearComboBox
                                placeholder="年度"
                                is年度={true}
                                isLoadEnded={年度isLoadEnded}
                                isRequired={false}
                                setIsLoadEnded={set年度isLoadEnded}
                                selectedValue={年度}
                                setSelectedValue={(v) => {
                                  set年度(v)
                                }}
                                ComboBox={年度ComboBox}
                                setComboBox={set年度ComboBox}></YearComboBox>
                            </div>
                          </div>
                          <Button
                            type="submit"
                            variant="primary"
                            disabled={isSearching}
                            onClick={(e) => {
                              e.stopPropagation()
                              e.preventDefault()
                              search()
                            }}>
                            <FontAwesomeIcon icon={faSearch} />
                            検索
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </Form>
              </Card.Body>
            </Collapse>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col>
          {/* 検索結果カード */}
          <Card>
            <Spinner searching={isSearching}></Spinner>
            <Card.Body>
              <Row>
                <Col>
                  {/* 検索条件表示コンポーネント */}
                  <DisplaySearchConditionLabel
                    displaySearchCondition={displaySearchCondition}
                  />
                </Col>
              </Row>
              <FlexGridOuter
                flexGrid={flexGrid}
                setFlexGrid={setFlexGrid}
                gridConstantProperties={CONST.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
                gridData={gridData}
                setGridData={setGridData}
                pageNumber={pageNumber}
                searchConditionClear={searchConditionClear}
                gridId={`${gridId}`}
                isEnablePageSize={"hidden"}
                isRestoreSearching={isRestoreSearching}
                setIsRestoreSearching={setIsRestoreSearching}
                gridInitialized={gridInitialized}
                setGridInitialized={setGridInitialized}
                pageSize={pageSize}
                setPageSize={setPageSize}
                style={{ maxHeight: "Auto" }}
                gridInitializedHandler={gridInitializedHandler}
                gridProperties={{
                  mergeManager: new RestrictedMergeManager(),
                  groupHeaderFormat: "{value}",
                  allowSorting: false,
                }}>
                <wjrGrid.FlexGridColumn
                  binding="営業所名"
                  width={240}
                  header="営業所"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="部所名"
                  width={240}
                  header="部所"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="今期予算"
                  cssClass={"number-col"}
                  width={120}
                  header="当年予算"
                  aggregate="Sum"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="今期実績"
                  cssClass={"number-col"}
                  width={120}
                  header="当年実績"
                  aggregate="Sum"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="前期実績"
                  width={120}
                  cssClass="number-col"
                  header="前年実績"
                  aggregate="Sum"></wjrGrid.FlexGridColumn>
                <wjrGrid.FlexGridColumn
                  binding="前期実績比"
                  width={120}
                  dataType={wjCore.DataType.Number}
                  format={"P"}
                  cssClass="number-col"
                  header="前年実績比"></wjrGrid.FlexGridColumn>
              </FlexGridOuter>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default UriageYosanZensyaList
